import axios from 'axios';

const getCotacoes = (params) => axios.get('/transportador/solicitacoes-fretes', {
  params,
});

const getCotacoesList = (params) => axios.get('/transportador/solicitacoes-fretes/list', {
  params,
});

const getCotacao = (id) => axios.get(`/cotacoes-fretes/${id}`);

const getSolicitacao = (id) => axios.get(`/transportador/solicitacoes-fretes/${id}`);

const getResposta = (id) => axios.get(`/transportador/respostas-fretes/${id}`);
const responder = (data) => {
  if (data.id) {
    return axios.put(`/transportador/respostas-fretes/${data.id}`, data);
  }
  return axios.post('/transportador/respostas-fretes', data);
};
const recusar = (id, data) => axios.put(`/transportador/solicitacoes-fretes/situacao/${id}`, data);

const getHistorico = (idCotacao, idResposta) => axios.get(`/cotacoes-fretes/${idCotacao}/respostas/${idResposta}/historico`);
const notificarNegociacao = (idResposta) => axios.post(`/notificacoes/negociacao_cotacao_frete/${idResposta}`, {});

export default {
  getCotacoes,
  getCotacao,
  getSolicitacao,
  getResposta,
  responder,
  recusar,
  getHistorico,
  notificarNegociacao,
  getCotacoesList,
};
